export default "<div class=\"home\">\n    <div class=\"container\">\n        Under construction\n    </div>\n</div>";